import type { ComponentType } from "react";
import { Navigate } from "react-router";
import { useAdminStatus } from "../../sharedHooks/useAdminStatus";

interface PrivateRouteProps {
	component: ComponentType;
	[key: string]: unknown;
}

export default function PrivateRoute({
	component: Component,
	...rest
}: PrivateRouteProps) {
	const isAdmin = useAdminStatus();
	return isAdmin ? <Component {...rest} /> : <Navigate to="/" replace />;
}
